export enum SynchronizedInboxesActionNameEnum {
  SYNC = 'SYNC',
  RE_AUTH = 'RE_AUTH',
}
